<div class="header-container" [style]="getBackgroundColor()">
    <div class="col-1">
        <div class="header-el-icon" [routerLink]="'/'">
            <app-icon [icon]="Icons.logoRzd"/>
        </div>
    </div>
    <div class="col-10" style="display: flex; justify-content: center;">
        <div class="header-el-title" [class]="class">
            <img [src]="image" alt="img">
        </div>
    </div>
    <div class="col-1" style="display: flex; justify-content: flex-end;">
        <div *ngIf="!openMenu" class="header-el-menu">
<!--            <div class="header-el-menu-text">-->
<!--                RU-->
<!--            </div>-->
            <div class="header-el-menu-icon">
                <app-icon [icon]="Icons.magnifiger"/>
            </div>
            <div class="header-el-menu-icon" (click)="openHeaderMenu()">
                <app-icon [icon]="Icons.menu"/>
            </div>
        </div>
        <div *ngIf="openMenu" class="header-el-cross-close" (click)="openHeaderMenu()">
            <app-icon [icon]="Icons.crossClose"/>
        </div>
    </div>
</div>
<div *ngIf="openMenu" class="header-menu-app">
    <app-menu (clickOn)="openHeaderMenu(); correctClick($event)"/>
</div>

